import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'search-box',
  template: `
  <div></div>
  <input type="text" placeholder="{{hint}}" class="form-control" (keyup.enter)="search($event.target.value)"
  [(ngModel)]="searchValue"> 
  <span class="hint-text">**Press Enter Key</span>
  `,
  styleUrls: ['./search-box.component.css']
})
export class SearchBoxComponent implements OnInit {
  @Input() hint;
  @Input() isEmit:boolean=false;

  @Output() searchData: any = new EventEmitter<any>();

  private searchValue:string;

  constructor(private _router:Router,private _activeRoute:ActivatedRoute) { }

  ngOnInit() {
    this._activeRoute.queryParams.subscribe(
      (params) => {
       if(params.search)
       this.searchValue=params.search;
      }
    )

  }

  search(value) {
    if(this.isEmit)
    this.searchData.emit(value);
    else
    this._router.navigate([], { queryParams: { search: this.searchValue } });

  }
}
